import React from "react";
import LoadingMessages from "./LoadingMessages";
import { CircularProgress } from "@mui/material";

const CourseListLoader = ({ messages }) => {
  const defaultMessages = [
    "Fetching your courses",
    "Loading course data",
    "Preparing course list",
    "Organizing course information",
    "Almost ready",
    "Getting everything set up",
    "Just a moment more",
  ];

  const messagesToUse = messages && messages.length > 0 ? messages : defaultMessages;

  return (
    <div style={{display: "flex",flexDirection: "column",alignItems: "center", justifyContent: "center", gap: "10px", height:"100%"}}>
      <CircularProgress size={40} />
      <LoadingMessages messages={messagesToUse} />
    </div>
  );
};

export default CourseListLoader;
